import React, { useState, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { BrowserRouter as Router, Switch, Route, Redirect } from 'react-router-dom';
import { commonClass } from '../../helpers/commonClass';
const LangSelector = () => {

    const reloadLangCssFile = (event) => {
        if (event == "ar" || event == "ur") {
            let myid = document.getElementById('ar_css');
            if (myid == null || myid == undefined) {
                findAndRomoveCss('ar_css', 'custom-arabic5.css?v1.4');
            }
        }
        else if (event == "ml") {
            let myid1 = document.getElementById('ml_css');
            if (myid1 == null || myid1 == undefined) {
                findAndRomoveCss('ml_css', 'custom-malayalam6.css?v1.1')
            }
        }
        else if (event == "es") {
            let myid1 = document.getElementById('es_css');
            if (myid1 == null || myid1 == undefined) {
                findAndRomoveCss('es_css', 'custom-spanish.css?v0.5')
            }
        }
        else if (event == "tl") {
            let myid1 = document.getElementById('tl_css');
            if (myid1 == null || myid1 == undefined) {
                findAndRomoveCss('tl_css', 'custom-tagalog1.css?v0.5')
            }
        }
        else if (event == "ta") {
            let myid1 = document.getElementById('ta_css');
            if (myid1 == null || myid1 == undefined) {
                findAndRomoveCss('ta_css', 'custom-tamil1.css?v0.7')
            }
        }
        else if (event == "hi") {
            let myid1 = document.getElementById('hi_css');
            if (myid1 == null || myid1 == undefined) {
                findAndRomoveCss('hi.css', 'custom-hindi.css?v0.5')
            }
        }
        else if (event == "id") {
            let myid1 = document.getElementById('id_css');
            if (myid1 == null || myid1 == undefined) {
                findAndRomoveCss('hi.css', 'custom-indonesia.css?v0.5')
            }
        }
        else if (event == "vi") {
            let myid1 = document.getElementById('vi_css');
            if (myid1 == null || myid1 == undefined) {
                findAndRomoveCss('hi.css', 'custom-vietnam.css?v0.5')
            }
        }
        else if (event == "km") {
            let myid1 = document.getElementById('km_css');
            if (myid1 == null || myid1 == undefined) {
                findAndRomoveCss('hi.css', 'custom-khmer.css.css?v0.5')
            }
        }
        else {
            findAndRomoveCss()
        }
    }

    const findAndRomoveCss = (cssname, css_path) => {
        if (cssname != undefined && css_path != undefined) {
            let css = document.createElement('link');
            css.id = cssname;
            css.href = './assets/css/' + css_path;
            css.rel = 'stylesheet';
            css.type = 'text/css';
            document.getElementById('myscpt').appendChild(css);
        }
        // Remove Pervious Css File
        let Wholecss = ['ml_css', 'ar_css', 'es_css', 'tl_css', 'ta_css', 'hi_css', 'id_css', 'vi_css', 'km_css']
        Wholecss = Wholecss.filter(a => a != cssname);
        Wholecss.forEach(element => {
            let css_file = document.getElementById(element);
            if (css_file != null && css_file != undefined) {
                css_file.remove();
            }
        });
    }

    const getCookie = (name) => {
        try {
            const value = `; ${document.cookie}`;
            const parts = value.split(`; ${name}=`);
            let lang_val = process.env.REACT_APP_DEFAULTLANGUAGE;
            if (parts.length >= 2) {
                let lst = value.split(`;`);
                let fobj = lst.filter(a => a.indexOf('gtlang=') >= 0);
                if (fobj && fobj.length > 0) {
                    let fobj1 = fobj[fobj.length - 1].split(`=`);
                    lang_val = fobj1[1];
                }
            }
            if (JSON.parse(localStorage.getItem('language'))) {
                lang_val = JSON.parse(localStorage.getItem('language'))
            }
            reloadLangCssFile(lang_val);
            return lang_val;
        }
        catch (ex) {
            return process.env.REACT_APP_DEFAULT_LANGUAGE;
        }
    };

    const { i18n } = useTranslation();
    const [selectedLang, setSelectedLang] = useState(getCookie("gtlang"));
    const all_lang = commonClass.AllLanguage();


    const changeLanguage = (event) => {
        reloadLangCssFile(event)
        i18n.changeLanguage(event);
        document.cookie = "gtlang=" + event;
        setSelectedLang(event);
        localStorage.setItem('language', JSON.stringify(event));
        const urlpath = window.location.pathname.split('/')[2];
        let getcountry = window.location.pathname.split('/')[1];
        getcountry = getcountry.split('-')[0];
        window.location.href = `/${getcountry}-${event}/${urlpath}`;
        // return <Redirect to="/"/>;
        // window.location.reload(); //for get some translation from db
    }
    useEffect(() => {
        window.setLangDoggle();
    }, [])


    return (
        <div className="selLanguage" onChange={changeLanguage} >
            <a className="selLangBtn language">
                {/* id="lstLang" */}
                <img src="./assets/img/icons/language.png?v0.1" />
                <span style={{ textTransform: 'uppercase' }} className="selectedLanguageName">{selectedLang}</span>
            </a>
            <ul className="selLangCont languageCont">
                {all_lang && all_lang.map((x, inx1) => <>
                    <li><a onClick={() => changeLanguage(x.lang)}><div><img src={`./assets/img/icons/flags/${x.countrycode}.png?v0.1`} /></div><span>{x.text}</span></a></li>
                </>
                )}
            </ul>
        </div>
    )
}

export default LangSelector;